import { render, staticRenderFns } from "./applyList.vue?vue&type=template&id=0b5d1266&scoped=true&"
import script from "./applyList.vue?vue&type=script&lang=js&"
export * from "./applyList.vue?vue&type=script&lang=js&"
import style0 from "./applyList.vue?vue&type=style&index=0&id=0b5d1266&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b5d1266",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\xingxingzu\\multi_merchant_web\\supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b5d1266')) {
      api.createRecord('0b5d1266', component.options)
    } else {
      api.reload('0b5d1266', component.options)
    }
    module.hot.accept("./applyList.vue?vue&type=template&id=0b5d1266&scoped=true&", function () {
      api.rerender('0b5d1266', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/aliApp/businessCooperation/applyList.vue"
export default component.exports